import { entities, reports } from '@/modules/catalog'

type Title = { zh: string; en: string }

// 单一标题来源：页头（AppShell）与菜单使用同一份名称。
// /records/* 上的原生工作台沿用 catalog 里的菜单名，避免“菜单叫 A、页头叫 B”。
const nativeEntityRoutes: Record<string, string> = {
  'native-transfers': 'transfers',
  'native-stocktakes': 'stock_takes',
  'native-scraps': 'scrap_orders',
  'processing-orders': 'production_orders',
}

const fixedTitles: Record<string, Title> = {
  'reporting-rules': { zh: '库存分析与预警规则', en: 'Inventory analysis and alert rules' },
  'reporting-alerts': { zh: '站内提醒', en: 'In-app reminders' },
  'sales-freights': { zh: '销售运输费用', en: 'Sales freight' },
  'sales-freight-corrections': { zh: '运输费用更正', en: 'Freight corrections' },
  'sales-after-sales': { zh: '客户售后', en: 'Customer claims' },
  'sales-after-sale-returns': { zh: '客户实物退回', en: 'Customer actual returns' },
  'sales-after-sale-replacements': { zh: '关联补寄', en: 'Linked replacements' },
  'customer-money': { zh: '客户收款与贷项', en: 'Customer receipts and credits' },
  'customer-refunds': { zh: '客户退款与反向', en: 'Customer refunds and corrections' },
  'customer-statement': { zh: '客户期间对账', en: 'Customer period statement' },
  'supplier-returns': { zh: '采购退供', en: 'Supplier returns' },
  'landed-costs': { zh: '采购费用', en: 'Procurement fees' },
  'supplier-invoices': { zh: '供应商发票', en: 'Supplier invoices' },
  'payment-instructions': { zh: '付款申请', en: 'Payment requests' },
  'supplier-activity': { zh: '供应商往来', en: 'Supplier activity' },
  'supplier-credits': { zh: '供应商贷项', en: 'Supplier credits' },
  'supplier-refunds': { zh: '供应商退款', en: 'Supplier refunds' },
}

export interface TitleRoute { name?: unknown; params?: Record<string, unknown> }

export function resolvePageTitle(route: TitleRoute, en: boolean, translate: (key: string) => string): string {
  const name = String(route.name ?? '')
  const pick = (title?: { title: string; titleEn: string }) => title ? (en ? title.titleEn : title.title) : ''
  const entityKey = nativeEntityRoutes[name]
  if (entityKey && entities[entityKey]) return pick(entities[entityKey])
  const fixed = fixedTitles[name]
  if (fixed) return en ? fixed.en : fixed.zh
  if (name.startsWith('reports-')) {
    const rep = reports.find(item => item.key === name.slice('reports-'.length))
    if (rep) return pick(rep)
  }
  if (name === 'records') return pick(entities[String(route.params?.entityKey ?? '')])
  if (name === 'reports') return pick(reports.find(item => item.key === String(route.params?.reportKey ?? '')))
  if (name === 'approvals') return translate('nav.approvals')
  if (name === 'approval-flows') return translate('nav.approvalFlows')
  if (name === 'role-permissions') return translate('nav.rolePermissions')
  if (name === 'user-admin') return translate('nav.userAdmin')
  if (name === 'document-numbering') return translate('nav.documentNumbering')
  return ''
}
